(function($) {

    $('.factions-list .faction-container').hide();

    var _nb_factions = $('.factions-list').data('nb-factions');
    var _nb_factions_to_display = $('.factions-list').data('nb-to-display');

    $('.factions-list .faction-container').slice(0, _nb_factions_to_display).show();

    var _nb_factions_visible = $('.factions-list .faction-container:visible').length;


    $('.factions-more-button .more-button').off('click').on('click', function (e) {

        e.preventDefault();


        $('.factions-list .faction-container').slice(0, _nb_factions_visible + _nb_factions_to_display).show();

        _nb_factions_visible = $('.factions-list .faction-container:visible').length;

        if (_nb_factions_visible >= _nb_factions) {
            $('.factions-more-button .btn-small').hide();
        }

    });




    $('#factions-groups-list .list-inline-item .btn, #factions-groups-dropdown .dropdown-item').off('click').on('click', function (e) {

        e.preventDefault();

        var _group = $(this).data('group');

        $('.factions-by-group').removeClass('active');
        $('.factions-by-group#factions-'+_group).addClass('active');


        $('#factions-groups-list .list-inline-item .btn').removeClass('active');
        $('#factions-groups-dropdown .dropdown-item').removeClass('active');

        $('#factions-groups-list .list-inline-item .btn[data-group='+_group+']').addClass('active');
        $('#factions-groups-dropdown .dropdown-item[data-group='+_group+']').addClass('active');

        $('#factions-groups-dropdown #dropdownGroup').text($('#factions-groups-dropdown .dropdown-item[data-group='+_group+']').html());

    });




})(jQuery);